import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const HAS_BACKEND = Boolean(BACKEND_URL.trim());

export const api = axios.create({ baseURL: API, timeout: 20000 });

function openEmailHandoff(subject, lines) {
  const params = new URLSearchParams({
    subject,
    body: lines.filter(Boolean).join("\n"),
  });
  window.location.href = `mailto:A@Austinsads.com?${params.toString()}`;
  return { id: "email-handoff", delivery: "email" };
}

export async function fetchDirections() {
  const { data } = await api.get("/directions");
  return data.directions;
}

export async function submitLead(payload) {
  if (!HAS_BACKEND) {
    return openEmailHandoff("Austin's Agents — workflow map", [
      `Name: ${payload.name}`,
      `Email: ${payload.email}`,
      `Brand: ${payload.brand || "Not provided"}`,
      `Store: ${payload.brand_url || "Not provided"}`,
      `Business area: ${payload.surface || "Not provided"}`,
      `Recurring bottleneck: ${payload.bottleneck}`,
      `Frequency: ${payload.frequency || "Not provided"}`,
      `Hours per week: ${payload.hours_per_week ?? "Not provided"}`,
      `Blended hourly cost: ${payload.blended_rate ?? "Not provided"}`,
      `Opening autonomy: ${payload.autonomy_comfort || "Not provided"}`,
      `Stack: ${(payload.stack || []).join(", ") || "Not provided"}`,
      `Revenue band: ${payload.revenue_band || "Not provided"}`,
      `Notes: ${payload.notes || "None"}`,
    ]);
  }
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function requestAsset(payload) {
  if (!HAS_BACKEND) {
    return openEmailHandoff(`Austin's Agents — ${payload.requested_asset}`, [
      `Email: ${payload.email}`,
      `Requested asset: ${payload.requested_asset}`,
      `Machine: ${payload.machine_id}`,
      `Brand: ${payload.brand || "Not provided"}`,
      `Store: ${payload.brand_url || "Not provided"}`,
    ]);
  }
  const { data } = await api.post("/asset-requests", payload);
  return data;
}

export async function fetchLeads(directionId = "all") {
  const { data } = await api.get("/leads", { params: { direction_id: directionId } });
  return data;
}

export async function fetchLeadStats() {
  const { data } = await api.get("/leads/stats");
  return data;
}

export async function updateLeadStatus(id, status) {
  const { data } = await api.patch(`/leads/${id}`, { status });
  return data;
}

export async function deleteLead(id) {
  const { data } = await api.delete(`/leads/${id}`);
  return data;
}
